module.exports = __webpack_public_path__ + "img/frame03_stamp.88eabefa.png";